import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

const loadProductsGroup = (data: any) => {
  return axios.get('/parameters/product-group-to-select', data)
}

export function useLoadProductsGroup(query: any) {
  return useQuery(['productsGroup', query], () => loadProductsGroup(query), {
    onError: () =>
      toast.error('Não foi possível carregar os grupos de produtos!', {
        toastId: 'loadProductsGroup'
      })
  })
}
